import { guestsRef } from '../../config/firebaseInstance'

const guestsService = () => {
  const _set = (docId, payload) => {
    return guestsRef.doc(docId).set(payload)
  }

  const _update = (docId, payload) => {
    return guestsRef.doc(docId).update(payload)
  }

  const _updateField = (docId, key, value) => {
    return guestsRef.doc(docId).update({ key, value })
  }

  const _delete = (docId) => {
    return guestsRef.doc(docId).delete()
  }

  const _getByDocId = (docId) => {
    return guestsRef.doc(docId).get()
  }

  return {
    _set,
    _update,
    _updateField,
    _delete,
    _getByDocId
  }
}

export default guestsService